import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import TextField from '../TextField';
import { Warning } from './CropGuidelines';

const ImageUploaderFieldWrapper = styled.div`
  margin: 24px 24px 24px 0;
  min-width: 220px;
  max-width: 440px;

  button {
    margin-right: 12px;
  }
  .MuiFormHelperText-root {
    margin: 0 0 0 2px;
  }
`;

const TextFieldsWrapper = styled.div`
  max-width: 936px;
  display: inline-block;
`;

const MetadataFields = ({
  addCredit,
  creditRequired,
  imageCredit,
  setImageCredit,
  imageCreditHelperText,
  creditError,
  addMetadata,
  imageTitle,
  setImageTitle,
  imageDescription,
  setImageDescription,
}) => (
  <TextFieldsWrapper>
    {addMetadata && (
      <ImageUploaderFieldWrapper>
        <TextField
          id="image-title"
          value={imageTitle || ''}
          onChange={
            ({ target: { value } }) => {
              setImageTitle(value);
            }
          }
          label="Title"
          aria-label="Title"
          name="image-title"
          variant="outlined"
          // eslint-disable-next-line max-len
          helperText="Title for caption, screen readers and lookbook searches (advised)"
          fullWidth
        />
      </ImageUploaderFieldWrapper>
    )}

    {addCredit && (
      <ImageUploaderFieldWrapper>
        <TextField
          id="image-credit"
          value={imageCredit || ''}
          onChange={
            ({ target: { value } }) => {
              setImageCredit(value);
            }
          }
          label={`Image Credit${creditRequired ? ' *' : ''}`}
          aria-label={`Image Credit${creditRequired ? ' *' : ''}`}
          name="image-credit"
          variant="outlined"
          helperText={imageCreditHelperText}
          fullWidth
        />
        {creditError && (
          <span>
            <Warning>
              {creditError}
            </Warning>
          </span>
        )}
      </ImageUploaderFieldWrapper>
    )}

    {addMetadata && (
      <ImageUploaderFieldWrapper>
        <TextField
          id="image-description"
          value={imageDescription || ''}
          onChange={
            ({ target: { value } }) => {
              setImageDescription(value);
            }
          }
          label="Description"
          aria-label="Description"
          name="image-description"
          variant="outlined"
          // eslint-disable-next-line max-len
          helperText="Detailed description for context and discoverability (optional)"
          fullWidth
          multiline
          minRows={2}
        />
      </ImageUploaderFieldWrapper>
    )}
  </TextFieldsWrapper>
);

MetadataFields.propTypes = {
  addCredit: PropTypes.bool,
  creditRequired: PropTypes.bool.isRequired,
  imageCredit: PropTypes.string,
  setImageCredit: PropTypes.func.isRequired,
  creditError: PropTypes.string,
  imageCreditHelperText: PropTypes.string,
  addMetadata: PropTypes.bool,
  imageTitle: PropTypes.string,
  setImageTitle: PropTypes.func.isRequired,
  imageDescription: PropTypes.string,
  setImageDescription: PropTypes.func.isRequired,
};

MetadataFields.defaultProps = {
  addCredit: false,
  addMetadata: false,
  imageCredit: '',
  imageCreditHelperText: '',
  creditError: '',
  imageTitle: '',
  imageDescription: '',
};

export default MetadataFields;
